module.exports = __webpack_public_path__ + "components/processBlock/circle-02.svg";